import { SearchOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form/form/submit/SubmitButton.tsx';
import { TopMenuIconButton } from '@framework/ui/components/button/TopMenuIconButton.tsx';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Button } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';

export interface IFilterDrawerButtonProps {
  /**
   * Il Form da inserire nel Drawer
   */
  children?: React.ReactNode;
  /**
   * Funzionalità Drawer
   */
  onOpen?: () => void;
  onClose?: () => void;
  onClear?: () => void;
  open?: boolean;
  /** Se filtrata mostriamo il pulsante "Rimuovi filtri" */
  isFiltered?: boolean;
  /** Mostrare i pulsanti di ricerca */
  showFormButtons?: boolean;
}

/**
 * Pulsante e Drawer Per Mobile del Form per la ricerca di domande FrontOffice.
 */
export function FilterDrawerButton(props: IFilterDrawerButtonProps) {
  const {
    onOpen,
    onClose,
    onClear,
    open,
    isFiltered,
    children,
    showFormButtons,
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <TopMenuIconButton
        icon={<SearchOutlined aria-label="Cerca" />}
        onClick={onOpen}
      />

      <Drawer
        styles={{
          body: { padding: 8 },
          header: { padding: 8 },
        }}
        height={'100%'}
        title={t('ui.filtri-di-ricerca', 'Filtri di ricerca')}
        onClose={onClose}
        open={open}
        placement="top"
      >
        {/* <StyledForm component="div"> */}
        {children}

        {showFormButtons && (
          <FlexRow
            gutter={24}
            left={
              isFiltered ? (
                <Button size="large" htmlType="reset" onClick={onClear}>
                  {t('ui.rimuovi-filtri', 'Rimuovi Filtri')}
                </Button>
              ) : undefined
            }
          >
            <SubmitButton
              isOutsideForm
              pristineMessage={t(
                'ui.nessun-filtro-modificato',
                'Nessun filtro modificato',
              )}
              block
              type="primary"
              icon={<SearchOutlined aria-hidden />}
            >
              {t('ui.cerca', 'Cerca')}
            </SubmitButton>
          </FlexRow>
        )}
        {/*</StyledForm> */}
      </Drawer>
    </>
  );
}
